import React from "react";
import { money2, signedMoney } from "../payrollHelpers";

function Line({ label, system, adjustment, final, isHours, testid }) {
  const fmt = (v) => (isHours ? Number(v || 0).toFixed(2) : money2(v));
  return (
    <div className="grid grid-cols-4 gap-2 py-2 border-b border-slate-100 text-[13px]" data-testid={testid}>
      <div className="font-semibold text-slate-800">{label}</div>
      <div className="text-slate-500">{fmt(system)}</div>
      <div className={adjustment > 0 ? "text-emerald-600" : adjustment < 0 ? "text-rose-600" : "text-slate-400"}>
        {adjustment ? (isHours ? `${adjustment > 0 ? "+" : ""}${Number(adjustment).toFixed(2)}` : signedMoney(adjustment)) : "—"}
      </div>
      <div className="font-bold text-slate-900">{fmt(final)}</div>
    </div>
  );
}

const OTHER_CATS = ["PTO", "SICK", "HOLIDAY", "PIECE_RATE", "OTHER_EARNING", "DEDUCTION", "OTHER"];

export default function SummaryTab({ row, adjustments }) {
  const sumCat = (cat) => (adjustments || []).filter((a) => a.category === cat).reduce((s, a) => s + a.adjustmentAmount, 0);
  const timeAdjHours = sumCat("TIME");
  const hourlyRate = (row.pay.model === "hourly" || row.pay.model === "hybrid") ? (row.pay.hourlyRate || 0) : 0;
  const regularPayAdj = timeAdjHours * hourlyRate;
  const commissionAdj = sumCat("COMMISSION");
  const bonusAdj = sumCat("BONUS") + sumCat("SPIFF");
  const salaryAdj = sumCat("SALARY");
  const otherAdj = OTHER_CATS.reduce((s, c) => s + sumCat(c), 0);

  const finalRegularHours = row.regularHours + timeAdjHours;
  const finalRegularPay = row.regularPay + regularPayAdj;
  const finalCommission = row.commission + commissionAdj;
  const finalBonus = row.bonus + bonusAdj;
  const finalSalary = row.salaryPay + salaryAdj;
  const grossFinal = finalRegularPay + row.otPay + finalCommission + finalBonus + row.flatPay + finalSalary + otherAdj;

  return (
    <div data-testid="payroll-summary-tab">
      <div className="grid grid-cols-4 gap-2 pb-2 text-[10.5px] font-bold uppercase tracking-wider text-slate-400">
        <div>Item</div><div>System</div><div>Adjustment</div><div>Final</div>
      </div>
      <Line label="Regular Hours" system={row.regularHours} adjustment={timeAdjHours} final={finalRegularHours} isHours testid="summary-line-regular-hours" />
      <Line label="Regular Pay" system={row.regularPay} adjustment={regularPayAdj} final={finalRegularPay} testid="summary-line-regular-pay" />
      {row.otPay > 0 && <Line label="Overtime Pay" system={row.otPay} adjustment={0} final={row.otPay} testid="summary-line-ot-pay" />}
      <Line label="Commission" system={row.commission} adjustment={commissionAdj} final={finalCommission} testid="summary-line-commission" />
      <Line label="Bonus" system={row.bonus} adjustment={bonusAdj} final={finalBonus} testid="summary-line-bonus" />
      {(row.salaryPay > 0 || salaryAdj !== 0) && <Line label="Salary" system={row.salaryPay} adjustment={salaryAdj} final={finalSalary} testid="summary-line-salary" />}
      {row.flatPay > 0 && <Line label="Piece Rate" system={row.flatPay} adjustment={0} final={row.flatPay} testid="summary-line-piece-rate" />}
      {otherAdj !== 0 && <Line label="Other Adjustments" system={0} adjustment={otherAdj} final={otherAdj} testid="summary-line-other" />}
      <div className="flex items-center justify-between mt-4 pt-3 border-t-2 border-slate-200">
        <div className="text-[13px] font-bold uppercase tracking-wide text-slate-700">Gross Pay</div>
        <div className="text-[18px] font-extrabold text-emerald-700" data-testid="summary-gross-final">{money2(grossFinal)}</div>
      </div>
    </div>
  );
}
